"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { CICType, RatingWithProfileInfoAndLevel } from "@/entities/IProfile";
import { SortDirection } from "@/entities/ISort";
import { ProfileRatersParamsOrderBy, RateMatter } from "@/enums";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { amIUser, cicToType, formatNumberWithCommas } from "@/helpers/Helpers";
import { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { CIC_META } from "@/components/user/utils/user-cic-status/UserCICStatus";
import UserCICTypeIconTooltipHeaders from "./UserCICTypeIconTooltipHeaders";
import UserCICTypeIconTooltipRate from "./UserCICTypeIconTooltipRate";
export default function UserCICTypeIconTooltip(t0) {
  const $ = _c(45);
  const {
    profile
  } = t0;
  const {
    address
  } = useSeizeConnectContext();
  const [isMyProfile, setIsMyProfile] = useState(true);
  let t1;
  if ($[0] !== profile.cic) {
    t1 = cicToType(profile.cic);
    $[0] = profile.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [cicType, setCicType] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== address || $[3] !== profile) {
    t2 = () => setIsMyProfile(amIUser({
      profile,
      address
    }));
    t3 = [profile, address];
    $[2] = address;
    $[3] = profile;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== profile.cic) {
    t4 = () => {
      setCicType(cicToType(profile.cic));
    };
    $[6] = profile.cic;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== profile) {
    t5 = [profile];
    $[8] = profile;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] !== profile.handle) {
    t6 = [QueryKey.PROFILE_RATERS, {
      handleOrWallet: profile.handle,
      matter: RateMatter.NIC,
      page: 1,
      pageSize: 1,
      order: SortDirection.DESC,
      orderBy: ProfileRatersParamsOrderBy.RATING,
      given: false
    }];
    t7 = async () => await commonApiFetch({
      endpoint: `profiles/${profile.handle}/cic/ratings/by-rater`,
      params: {
        page: "1",
        page_size: "1",
        order: SortDirection.DESC.toLowerCase(),
        order_by: ProfileRatersParamsOrderBy.RATING.toLowerCase(),
        given: "false"
      }
    });
    $[10] = profile.handle;
    $[11] = t6;
    $[12] = t7;
  } else {
    t6 = $[11];
    t7 = $[12];
  }
  const t8 = !!profile.handle;
  let t9;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = {
      queryKey: t6,
      queryFn: t7,
      enabled: t8,
      placeholderData: keepPreviousData
    };
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const {
    data: ratings
  } = useQuery(t9);
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <UserCICTypeIconTooltipHeaders />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>Rating:</span>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== profile.cic) {
    t12 = formatNumberWithCommas(profile.cic);
    $[19] = profile.cic;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <span className="tw-block tw-text-iron-200 tw-font-semibold">{t11}<span className="tw-ml-1 tw-text-iron-200 tw-font-bold">{t12}</span></span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span>Status:</span>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = `${CIC_META[cicType].class} tw-ml-1 tw-font-bold`;
  const t16 = CIC_META[cicType];
  let t17;
  if ($[24] !== t15 || $[25] !== t16.title) {
    t17 = <span className="tw-block tw-text-iron-200 tw-font-semibold">{t14}<span className={t15}>{t16.title}</span></span>;
    $[24] = t15;
    $[25] = t16.title;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span>Raters:</span>;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  const t19 = ratings?.count ?? 0;
  let t20;
  if ($[28] !== t19) {
    t20 = formatNumberWithCommas(t19);
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== t20) {
    t21 = <span className="tw-block tw-text-iron-200 tw-font-semibold">{t18}<span className="tw-ml-1 tw-font-bold tw-text-iron-200">{t20}</span></span>;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t13 || $[33] !== t17 || $[34] !== t21) {
    t22 = <div className="tw-mt-4 tw-space-y-0.5">{t13}{t17}{t21}</div>;
    $[32] = t13;
    $[33] = t17;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== cicType) {
    t23 = cicType === CICType.INACCURATE && <div className="mt-2"><p className="tw-mb-0 tw-mt-1 tw-text-sm tw-text-iron-400 tw-font-medium">This profile is at risk of losing its handle if its NIC does not turn positive. The detailed process will go live after the experimental period is complete.</p></div>;
    $[36] = cicType;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== isMyProfile || $[39] !== profile) {
    t24 = !isMyProfile && <UserCICTypeIconTooltipRate profile={profile} />;
    $[38] = isMyProfile;
    $[39] = profile;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t22 || $[42] !== t23 || $[43] !== t24) {
    t25 = <div className="tw-p-4 tw-border tw-border-solid tw-border-white/10 tw-rounded-lg">{t10}{t22}{t23}{t24}</div>;
    $[41] = t22;
    $[42] = t23;
    $[43] = t24;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  return t25;
}